import { Link } from "react-router-dom";

const TOKEN_RE = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g;
const LINK_PARTS = /^\[([^\]]+)\]\(([^)]+)\)$/;

export const stripLinks = (text) => text.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1").replace(/\*\*/g, "");

export function FaqRichText({ text }) {
  return text.split(TOKEN_RE).map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return (
        <strong key={i} className="font-semibold text-navy-800">
          {part.slice(2, -2)}
        </strong>
      );
    }
    const m = part.match(LINK_PARTS);
    if (!m) return part;
    return (
      <Link
        key={i}
        to={m[2]}
        data-testid="faq-inline-link"
        className="text-[#F26522] font-semibold underline decoration-[#F26522]/30 underline-offset-2 hover:decoration-[#F26522] transition-colors"
      >
        {m[1]}
      </Link>
    );
  });
}
